import PropTypes from 'prop-types';
import { FormGroup, Label, TextField } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

import styles from './NpiField.module.scss';

const NpiField = ({ value, onChange, disabled }) => {
  const handleValueChange = event => onChange(event);

  return (
    <div className={styles.npiField}>
      <FormGroup>
        <Label size="sm" for={credentialForm.npiFieldId}>
          {credentialForm.npiFieldLabel}
        </Label>
        <TextField
          id={credentialForm.npiFieldId}
          size="sm"
          value={value}
          onChange={handleValueChange}
          disabled={disabled}
        />
      </FormGroup>
    </div>
  );
};

NpiField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

NpiField.defaultProps = {
  value: '',
  onChange: noop,
  disabled: false,
};

export default NpiField;
